import 'custom-event-polyfill';
import console from './utils/console';
import $ from 'jquery';
import './utils/jquery-events';
import _ from 'underscore';
import History from './utils/history';
import FastClick from 'fastclick';
import stacktrace from 'stacktrace-js';
import bootLoadFonts from './app/boot/boot-load-fonts';
import InitData from './app/data/init-data';
import loadModules from './app/pages/load-modules';
import './components/navigation/main-navigation';
import onReady from './utils/on-ready';

export default new function () {
    window._ = window._ || _;
    window.$ = window.$ || $;
    window.printStackTrace = stacktrace;
    const initData = InitData.currentOrSet();

    if (!initData) {
        return;
    }

    if (window.addEventListener) {
        window.addEventListener('load', function () {
            if (initData.enableFastClick) {
                new FastClick(document.body);
            }
            bootLoadFonts();
        }, false);
    };

    onReady(() => {
        loadModules(initData);
    });
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app.js